import * as Yup from 'yup';
import {
  stringValidation,
  emailValidation,
  phoneValidation,
  cityValidation,
  zipValidation,
} from 'src/services/validation';

const ContactSchema = Yup.object().shape({
  partyName: stringValidation(),
  emailAddr: emailValidation(),
  phone: phoneValidation(),
  cellPhone: phoneValidation(),
  addrStreet: stringValidation(),
  addrCity: cityValidation(),
  addrState: stringValidation(),
  addrZip: zipValidation(),
  partyType: stringValidation(),
});

export default ContactSchema;
